
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { maxConcurrentConnectionsMetadata, recursiveCheckboxMetadata } from '../consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const amazonS3DatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.amazonS3.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.amazonS3.linkedServiceType],
    displayName: stringResources.AmazonS3_DisplayText,
    isSource: true,
    isSink: false,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-100x100-AmazonS3'
    },
    isFirstClass: true,
    category: ['File'],
    supportGetMetadataActivity: true,
    supportRootFolder: false,
    supportIncrementalBinaryCopy: true,
    supportDeleteActivity: true,
    lookupActivityRequiredProperties: ['bucketName'],
    copySourceControls: [
        recursiveCheckboxMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySourceRequiredProperties: ['bucketName']
};
